import { render, staticRenderFns } from "./SearchMovies.vue?vue&type=template&id=4d47e954&"
import script from "./SearchMovies.vue?vue&type=script&lang=js&"
export * from "./SearchMovies.vue?vue&type=script&lang=js&"
import style0 from "./SearchMovies.vue?vue&type=style&index=0&id=4d47e954&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports